module.exports = __webpack_public_path__ + "img/deletegreyBin.54fd22ee.svg";